import { declOfNum } from '../../../helpers/dspx-utils';

export const generateExpWithNum = (num, words) =>
  `${num} ${declOfNum(num, words)}`;
